(() => {
 const chosenProducts=new Set();
 const initializedProducts=new Set();
 const initialVariant=new URL(window.location.href).searchParams.get('variant');
 let scheduled=false;
 let deliveryZone='';
 const productKey=picker=>picker.dataset.productId;
 function sizeGroup(picker){return picker.querySelector('[data-madar-size-group]');}
 function needsSize(picker){const group=sizeGroup(picker);if(!group)return false;const choices=group.querySelectorAll('input[type="radio"],select option');return choices.length>1;}
 function initialize(){
  scheduled=false;
  document.querySelectorAll('[data-madar-size-picker]').forEach(picker=>{
   if(!needsSize(picker))return;
   if(!initializedProducts.has(productKey(picker))){initializedProducts.add(productKey(picker));try{const variant=JSON.parse(picker.querySelector('script[type="application/json"]').textContent);if(initialVariant&&String(variant?.id)===initialVariant)chosenProducts.add(productKey(picker));}catch{}}
   const ready=chosenProducts.has(productKey(picker));
   const group=sizeGroup(picker);
   const prompt=picker.querySelector('[data-madar-size-prompt-text]');
   if(prompt)prompt.hidden=ready;
   if(ready)return;
   group.querySelectorAll('input[type="radio"]:checked').forEach(input=>{input.checked=false;});
   const select=group.querySelector('select');
   if(select){let promptOption=select.querySelector('option[value=""]');if(!promptOption){promptOption=document.createElement('option');promptOption.value='';promptOption.disabled=true;promptOption.textContent=picker.dataset.madarChooseSize;select.prepend(promptOption);}select.value='';}
   const section=picker.closest('.shopify-section');
   section?.querySelectorAll('[name="add"],[data-buy-start],sticky-add-to-cart button').forEach(button=>{if(!button.disabled)button.disabled=true;});
  });
  document.querySelectorAll('madar-shipping-estimate').forEach(element=>element.refresh?.());
 }
 function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(initialize);}}
 window.madarSizeIsReady=form=>{
  const section=form?.closest('.shopify-section')||document.querySelector('main [data-madar-size-picker]')?.closest('.shopify-section');
  const picker=section?.querySelector('[data-madar-size-picker]');
  if(!picker||!needsSize(picker)||chosenProducts.has(productKey(picker)))return true;
  const prompt=picker.querySelector('[data-madar-size-prompt-text]');
  if(prompt)prompt.hidden=false;
  sizeGroup(picker)?.scrollIntoView({behavior:'smooth',block:'center'});
  sizeGroup(picker)?.querySelector('input,select')?.focus({preventScroll:true});
  return false;
 };
 document.addEventListener('change',event=>{
  const field=event.target;
  if(!(field instanceof Element))return;
  const picker=field.closest('[data-madar-size-picker]');
  if(picker&&field.closest('[data-madar-size-group]')){chosenProducts.add(productKey(picker));const prompt=picker.querySelector('[data-madar-size-prompt-text]');if(prompt)prompt.hidden=true;}
 },true);
 document.addEventListener('submit',event=>{
  if(event.target.matches('form[action*="/cart/add"]')&&!window.madarSizeIsReady(event.target)){event.preventDefault();event.stopImmediatePropagation();}
 },true);
 document.addEventListener('click',event=>{
  const target=event.target instanceof Element?event.target:null;
  const button=target?.closest('[name="add"],[data-buy-start],sticky-add-to-cart button');
  if(button&&!window.madarSizeIsReady(button.closest('form'))){event.preventDefault();event.stopImmediatePropagation();return;}
  const link=target?.closest('.m-card a[href],.md-dice-card a[data-product-link]');
  if(link&&event.button===0&&!event.ctrlKey&&!event.metaKey&&!event.shiftKey&&!event.altKey&&link.target!=='_blank'){
   const url=new URL(link.href,window.location.href);
   if(url.origin===window.location.origin&&url.pathname.includes('/products/')){event.preventDefault();event.stopImmediatePropagation();window.location.assign(url.href);}
  }
 },true);
 document.addEventListener('submit',event=>{
  if(!event.target.matches('form[action*="localization"]'))return;
  const language=event.submitter?.getAttribute('value')||event.target.querySelector('[name="language_code"]')?.value;
  if(language)try{localStorage.setItem('madar-language',language);}catch{}
 });
 if(!customElements.get('madar-shipping-estimate'))customElements.define('madar-shipping-estimate',class extends HTMLElement{
  connectedCallback(){
   if(!this.ready){this.ready=true;this.addEventListener('change',event=>{if(event.target.matches('select')){deliveryZone=event.target.value;this.refresh();}});}
   this.refresh();
  }
  refresh(){
   const select=this.querySelector('select');
   if(!select)return;
   if(deliveryZone)select.value=deliveryZone;
    const fee=Number(select.value);
    const format=new Intl.NumberFormat(document.documentElement.lang==='ar'?'ar-EG':'en-EG',{style:'currency',currency:this.dataset.currency||'EGP'});
    const values={'[data-shipping-fee]':select.value?format.format(fee/100):'—','[data-shipping-total]':select.value?format.format((Number(this.dataset.subtotal)+fee)/100):'—','[data-delivery-time]':select.value?(fee===6000?this.dataset.local:this.dataset.other):''};
    for(const [selector,value] of Object.entries(values)){const node=this.querySelector(selector);if(node&&node.textContent!==value)node.textContent=value;}
  }
 });
 function start(){initialize();new MutationObserver(schedule).observe(document.querySelector('main')||document.body,{childList:true,subtree:true});}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
